import { gql, TypedDocumentNode } from '@apollo/client';

import {
  LoginMutation,
  LoginMutationVariables,
  RegisterMutation,
  RegisterMutationVariables,
  LogoutMutation,
  LogoutMutationVariables,
} from '../generated';

export const LOGIN: TypedDocumentNode<LoginMutation, LoginMutationVariables> =
  gql`
    mutation Login($input: LoginInput!) {
      login(input: $input) {
        user {
          id
          email
        }
      }
    }
  `;

export const REGISTER: TypedDocumentNode<
  RegisterMutation,
  RegisterMutationVariables
> = gql`
  mutation Register($input: RegisterInput!) {
    register(input: $input) {
      user {
        id
        email
      }
    }
  }
`;

export const LOGOUT: TypedDocumentNode<
  LogoutMutation,
  LogoutMutationVariables
> = gql`
  mutation Logout {
    logout {
      success
    }
  }
`;
